(function () {
    "use strict";

    angular.module("showcaseApp").controller("HomeController", HomeController);

    HomeController.$inject = [
        "$window",
        "$rootScope",
        "$scope",
        "$translate",
        "$localStorage",
        "Principal",
        "StoreService",
        "HubService",
        "HomeService",
        "SatisfactionSurveyService",
        "$timeout",
        "$state",
        "SellerCampaignService"
    ];

    function HomeController(
        $window,
        $rootScope,
        $scope,
        $translate,
        $localStorage,
        Principal,
        StoreService,
        HubService,
        HomeService,
        SatisfactionSurveyService,
        $timeout,
        $state,
        SellerCampaignService
    ) {
        var vm = this;

        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isHubContext = $localStorage.defaultStore.hubContext;
        vm.account = undefined;
        vm.userProfile = undefined;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null,
        };

        vm.statusMap = {
            PENDING: 'PENDING',
            DOING: 'DOING',
            DONE: 'DONE'
        };

        vm.$onInit = init;

        var storeId = $localStorage.defaultStore.storeId;
        var userId = $localStorage.userId;
        var sellerCampaignsLocalStorageKey = 'campaignSellerlistFilter_' + userId + '_' + storeId;

        vm.filter = !angular.isUndefined($localStorage[sellerCampaignsLocalStorageKey]) ? $localStorage[sellerCampaignsLocalStorageKey] : {
            status: [
                {
                    id: vm.statusMap.PENDING,
                    label: $translate.instant('seller-campaigns.list.badges.pending')
                },
                {
                    id: vm.statusMap.DOING,
                    label: $translate.instant('seller-campaigns.list.badges.in-progress')
                },
                {
                    id: vm.statusMap.DONE,
                    label: $translate.instant('seller-campaigns.list.badges.done')
                }
            ],
            search: "",
            orderBy: 'expirationDate',
            orderDirection: "asc",
            deadline: ""
        };

        vm.goTo = function (url) {
            if (angular.isObject(url)) {
                $state.go(url.state, url.params);
            } else {
                $state.go(url);
            }
        };

        function init() {
            vm.loading = true;
            getAccount();
        }

        function getButtonOptions() {
            if (vm.isAmbassador){
                vm.buttons = [
                    {
                        label: vm.isImmoContext
                            ? 'global.menu.admin.bags-immo'
                            : 'global.menu.admin.bags',
                        icon: vm.isImmoContext
                            ? 'icon-ksc-catalog-light'
                            : 'icon-ksc-bag-light',
                        url: 'bag', active: true },
                ];

                if (!vm.isImmoContext) {
                    vm.buttons.push({
                        label: 'global.menu.admin.orders',
                        icon: 'icon-ksc-cart-circle-check-light',
                        url: 'invoices',
                        active: true
                    });
                }

                vm.buttons.push({
                    label: 'global.menu.admin.reports',
                    icon: 'icon-ksc-chart-line-light',
                    url: {
                        state: 'seller-individual-performance',
                        params: { report: 'seller-individual-performance' }
                    },
                    active: true
                });
                return
            }
            if (vm.isHubContext) {
                var hubFlyersButton = {
                    label: vm.isImmoContext
                        ? 'global.menu.admin.developments'
                        : 'global.menu.admin.flyersManagement',
                    icon: vm.isImmoContext
                        ? 'icon-ksc-house-building-light'
                        : 'icon-ksc-tags-light-1',
                    url: 'hub-flyers',
                };

                var brandsButton = {
                    label: vm.isImmoContext
                        ? 'flyers.home.brands-immo'
                        : 'flyers.home.brands',
                    icon: vm.isImmoContext
                        ? 'icon-ksc-flag-swallowtail-light'
                        : 'icon-ksc-bookmark-light',
                    url: 'brands-list',
                };

                vm.buttons = [
                    { label: 'global.hub.store', icon: 'icon-ksc-store-light', url: 'hub-management' },
                    hubFlyersButton,
                    brandsButton,
                    { label: vm.isImmoContext ? 'global.hub.seller-schedule' : 'global.hub.campaigns', icon: 'icon-ksc-bullhorn-light', url: 'campaign' },
                    { label: 'global.menu.admin.hub-performance', icon: 'icon-ksc-chart-line-light', url: { state: 'hub-performance', params: { report: 'hub-performance' } } },
                    { label: 'global.hub.file-manager', icon: 'icon-ksc-folder-magnifying-glass-light', url: 'file-manager' },
                ];
            } else if (vm.isImmoContext) {
                vm.importHubButton = {
                    label: 'home.import-hub.title-immo',
                    description: 'home.import-hub.description-immo',
                    icon: 'icon-ksc-building-magnifying-glass-light',
                    url: 'flyers.import-hub.select-flyers'
                };

                vm.buttons = [
                    { label: 'flyers.home.title-immo', icon: 'icon-ksc-house-building-light', url: 'flyers', active: true },
                    { label: 'global.menu.admin.bags-immo', icon: 'icon-ksc-catalog-light', url: 'bag', active: true },
                    { label: 'global.menu.admin.sales-funnel', icon: 'icon-ksc-table-columns-light', url: 'sales-funnel', active: true },
                    { label: 'global.menu.admin.customers', icon: 'icon-ksc-user-group-simple-light', url: 'customers', active: true },
                    { label: 'global.menu.admin.communication', icon: 'icon-ksc-comment-dots-light', url: 'communication', active: true },
                    { label: 'global.menu.admin.showcaseManagement', icon: 'icon-ksc-window-thin', url: 'showcases' , active: true},
                ];
            } else {
                vm.importHubButton = {
                    label: 'home.import-hub.title',
                    description: 'home.import-hub.description',
                    icon: 'icon-ksc-registered-light',
                    url: 'flyers.import-hub'
                };

                vm.buttons = [
                    { label: 'global.menu.admin.flyersManagement', icon: 'icon-ksc-tags-light-1', url: 'flyers', active: true },
                    { label: 'global.menu.admin.bags', icon: 'icon-ksc-bag-light', url: 'bag', active: true },
                    { label: 'global.menu.admin.orders', icon: 'icon-ksc-cart-circle-check-light', url: 'invoices', active: true },
                    { label: 'global.menu.admin.customers', icon: 'icon-ksc-user-group-simple-light', url: 'customers', active: true },
                    { label: 'global.menu.admin.communication', icon: 'icon-ksc-comment-dots-light', url: 'communication', active: true },
                    { label: 'global.menu.admin.sales-funnel', icon: 'icon-ksc-table-columns-light', url: 'sales-funnel', active: true },
                ];

            }
        }

        function getAccount() {
            Principal.identity(false).then(function (account) {
                vm.account = account;
                vm.userProfile = vm.account.userProfiles[0];
                vm.isTrialStore = isTrial(vm.account);

                vm.isAmbassador = vm.userProfile.profileId === 7;
                getButtonOptions();

                $timeout(function () {
                    if ($window.OneSignal) {
                        $window.OneSignal.push(function () {
                            OneSignal.Notifications.addEventListener(
                                "permissionChange",
                                eventListener
                            );
                            $window.OneSignal.Notifications.requestPermission();
                        });
                    }
                }, 4000);

                if (vm.account.isHubAdmin) {
                    HubService.getHubByOwner(vm.account.id).then(function (
                        result
                    ) {
                        vm.hub = result;
                        $localStorage.hub = vm.hub;
                    });
                } else {
                    HubService.getHubByStoreId(
                        account.userProfiles[0].storeId
                    ).then(function (result) {
                        vm.hub = result;
                        $localStorage.hub = vm.hub;
                    });
                }
                if (account.userProfiles) {
                    if (
                        $rootScope.ADMIN_SYSTEM_ID !==
                        account.userProfiles[0].storeId
                    ) {
                        getPendencies(account.userProfiles[0].storeId);
                    }
                }

                Principal.hasPlan("ESSENCIAL,SHOWKASE,IMPULSO,ESCALA").then(function (hasPlan) {
                    Principal.hasPlan("LIGHT").then(function (hasLightPlan) {

                        if (vm.isTrialStore) {
                            vm.buttons.forEach(function (button) {
                                button.active = true;
                            });
                            return;
                        }

                        vm.buttons.forEach(function (button) {
                            if (['customers', 'sales-funnel', 'communication'].includes(button.url)) {
                                if (hasLightPlan) {
                                    button.active = ['customers', 'sales-funnel'].includes(button.url);
                                } else {
                                    button.active = hasPlan;
                                }
                            } else {
                                button.active = true;
                            }
                        });
                    });
                });
                $translate.use(vm.account.langKey);

                if (vm.account.acceptedTerm) {
                    showModalSatisfaction();
                }
            });
        }

        $scope.$on("authenticationSuccess", function () {
            getAccount();
        });

        function isTrial (account) {
            return !isNullOrUndefined(account) && !isNullOrUndefined(account.remainingTime)
                && account.remainingTime > 0 && account.remainingTime <= 7;
        }

        function eventListener(event) {
            if (event) {
                if (
                    $window.OneSignal &&
                    $window.OneSignal.User &&
                    $window.OneSignal.User._currentUser
                ) {
                    Principal.savePushNotificationId(
                        $window.OneSignal.User._currentUser.onesignalId
                    ).then(function (response) {
                        // TODO: Some code
                    });
                }
            }
        }

        function showModalSatisfaction() {
            SatisfactionSurveyService.checkIfStoreNew(
                vm.account.userProfiles[0].storeId
            ).then(function (response) {
                if (!response.data) {
                    SatisfactionSurveyService.checkIfNotExpiredEvaluation(
                        vm.account.userProfiles[0].storeId,
                        vm.account.id
                    ).then(function (response) {
                        if (!response.data) {
                            SatisfactionSurveyService.rateStore().then(
                                function () {}
                            );
                        }
                    });
                }
            });
        }

        function getPendencies(storeId) {
            HomeService.getStoreInfo(storeId)
                .then(function (response) {
                    vm.storePendencies = response.data;
                    if (vm.storePendencies.hasPublishedShowcase) {
                        getSellerCampaigns(vm.paginationOptions, vm.filter);
                    } else {
                        vm.loading = false;
                    }
                })
                .catch(function () {
                    vm.loading = false;
                });
        }

        function calculatePercentage(done, total) {
            const doneFloat = parseFloat(done);
            const totalFloat = parseFloat(total);

            if (totalFloat <= 0) return 0;

            const percentage = (doneFloat/total) * 100;
            return percentage.toFixed(0);
        }

        function getContactMessage(percentage, done, total) {
            percentage = parseInt(percentage, 10);

            var baseKey = "home.activities.description.";
            var suffix = "";

            if (percentage === 0) {
                suffix = "none";
            } else if (percentage > 0 && percentage <= 25) {
                suffix = "start";
            } else if (percentage > 25 && percentage <= 75) {
                suffix = "progress";
            } else if (percentage > 75 && percentage < 100) {
                suffix = "almost";
            } else if (percentage === 100) {
                suffix = "done";
            } else if (percentage > 100) {
                suffix = "exceeded";
            }

            var firstPartKey = baseKey + suffix + ".first-part";
            var secondPartKey = baseKey + suffix + ".second-part";

            return {
                firstPart: $translate.instant(firstPartKey, { done: done, total: total }),
                secondPart: $translate.instant(secondPartKey, { done: done, total: total })
            };
        }

        function getSellerCampaigns(pagination, filter) {
            var params = angular.copy(filter);
            var formatedStatusFilter = params.status.map(function (item) {
                return item.id;
            });
            var formattedDeadline = params.deadline ? params.deadline.value : "";
            params.page = pagination.page;
            params.size = pagination.size;
            params.status = formatedStatusFilter;
            params.myAgendas = vm.selectedTab === vm.isMyAgendas;
            params.deadline = formattedDeadline;

            SellerCampaignService.findProgressBySellerId(params).then(
                function (response) {

                    vm.report = response.data;
                    vm.percentage = calculatePercentage(
                        vm.report.totalActivitiesFinished,
                        vm.report.totalActivities
                    );

                    vm.contactDescription = getContactMessage(
                        vm.percentage,
                        vm.report.totalActivitiesFinished,
                        vm.report.totalActivities
                    );

                    vm.loading = false;
                }
            ).catch(function (err) {
                vm.loadingSellerCampaings = false;
            });
        }
    }
})();
